import { round } from 'lodash-es';
import * as screenLocation from '../constants/screenLocation';
import { getCurrentScale, getHotspotByID, getScreen } from '../selectors';
export function getMissedClickPosition(state, screenID, clickLocation, event) {
    var relativeClickPosition = getRelativeClickPosition(state, event);
    var screen = getScreen(state, screenID);
    if (clickLocation === screenLocation.FOOTER) {
        relativeClickPosition.y += screen.footer.y;
    }
    if (clickLocation === screenLocation.BODY && screen.header) {
        relativeClickPosition.y += screen.header.y;
    }
    return relativeClickPosition;
}
export function getOverlayMissedClickPosition(state, hotspotID, clickLocation, event) {
    var relativeClickPosition = getRelativeClickPosition(state, event);
    var hotspot = getHotspotByID(state, hotspotID);
    var screen = getScreen(state, hotspot.destinationScreenID);
    if (clickLocation === screenLocation.FOOTER) {
        relativeClickPosition.y += screen.footer.y;
    }
    return relativeClickPosition;
}
export function getClickPosition(state, hotspotID, event) {
    var relativeClickPosition = getRelativeClickPosition(state, event);
    var hotspot = getHotspotByID(state, hotspotID);
    return {
        x: hotspot.x + relativeClickPosition.x,
        y: hotspot.y + relativeClickPosition.y,
    };
}
function getRelativeClickPosition(state, event) {
    var pageX = event.pageX, pageY = event.pageY;
    var clickedElemet = event.target;
    var _a = clickedElemet.getBoundingClientRect(), left = _a.left, top = _a.top;
    var relativeClickPosition = { x: pageX - left, y: pageY - top };
    return unscale(state, relativeClickPosition);
}
function unscale(state, point) {
    var scale = getCurrentScale(state);
    // TODO remove this hack to get actual scale value
    var actualScale = scale(100000) / 100000;
    // ////////////////////////////////////////////////
    return { x: round(point.x / actualScale), y: round(point.y / actualScale) };
}
